






























































/**
 * see src\store\snackbar\index.ts and
 * src\plugins\services\services.plugin.ts
 */
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { SnackbarMessage } from '@/plugins/services/services.plugin';
import StringHelper from '@/helpers/StringHelper';

const storeModule = 'snackbar';

export default Vue.extend({
  name: 'AlpineSnackbar',
  filters: {
    actionLabel(val: string): string {
      return StringHelper.isNullOrWhiteSpace(val) ? 'Retry' : val;
    },
  },
  components: {
    AlpineSnackbarHint: () => import('@/components/snackbars/AlpineSnackbarHint.vue'),
  },
  computed: {
    ...mapState(storeModule, ['messages']),
  },
  methods: {
    ...mapActions(storeModule, ['removeMessage']),
    handleAction(msg: SnackbarMessage): void {
      msg.action.callback();
      this.removeMessage(msg.id);
    },
  },
});
